namespace TabAurous.Production {
    export interface JobWorkSettlementDetailsForm {
        ProductTypeCode: Serenity.StringEditor;
        KnockOff: Serenity.DecimalEditor;
        Rate: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        ProductId: Serenity.LookupEditor;
        PureWeight: Serenity.DecimalEditor;
    }

    export class JobWorkSettlementDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkSettlementDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkSettlementDetailsForm.init)  {
                JobWorkSettlementDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.LookupEditor;

                Q.initFormType(JobWorkSettlementDetailsForm, [
                    'ProductTypeCode', w0,
                    'KnockOff', w1,
                    'Rate', w1,
                    'Amount', w1,
                    'ProductId', w2,
                    'PureWeight', w1
                ]);
            }
        }
    }
}
